module.exports = __webpack_public_path__ + "img/bank-banco-nacion.d78e743c.jpg";